// extracted by mini-css-extract-plugin
export default {"container":"List-module--container--1s9XD","item":"List-module--item--4PnAf","card":"List-module--card--3woLr","icon":"List-module--icon--1Ea__","text":"List-module--text--2wTKE"};